import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { getRadiantV2Tokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { LENDING_POOL_ADDRESSES } from '../constants';
export var Repay = createPlugin({
    protocol: 'RADIANTV2',
    type: 'ACTION',
    method: 'repay',
    supportedContracts: LENDING_POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'radiant_lending_pool_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getRadiantV2Tokens({ chainId: chainId }) }),
                    amount: new FctValue({ destination: 'wei_amount' }),
                    rateMode: new FctValue({ options: [{ value: '1' }, { value: '2' }] }),
                    onBehalfOf: new FctAddress({}),
                },
            },
            output: {
                value: new FctValue({ innerIndex: 0 }),
            },
        });
    },
    requiredApprovals: function (params) {
        var _a = params.methodParams, asset = _a.asset, amount = _a.amount, onBehalfOf = _a.onBehalfOf;
        return [
            {
                to: asset.value,
                from: onBehalfOf.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: amount.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
